// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"08d9ee97","476":"5b4bb516"}[chunkId] + ".chunk.js";
};